import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { SupportedLanguage } from "../interfaces";

/**
 * Hold the app in one language for as long as the caller is mounted.
 *
 * The sanctioned home for this effect, next to `useTrackOnMount`, and for the
 * same reason: a page that exists to render in a language the viewer did not
 * choose has to set it somewhere, and the webapp React rules want that in a
 * named hook rather than an effect grown inside a business component.
 *
 * Global, not scoped to an `I18nextProvider`. `useActiveLang` resolves from the
 * shared instance and the localized announcement artwork reads it, so one lever
 * moves the copy and the images together; a provider would move only the copy.
 * The language detector caches nothing (`config/i18n`), so this outlives neither
 * the tab nor a reload.
 */
export function usePinnedLanguage(language: SupportedLanguage): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    void i18n.changeLanguage(language);
  }, [i18n, language]);
}
